import React from "react";

const MealContext = React.createContext();

export default MealContext;
